import React from "react";
import Notification from "./Notification";
import "./styles.scss";
import { log_error } from "../../../api";
import FullPageSpinner from "../../FullPageSpinner";
import _ from "lodash";
import { indexNotifications } from "../../../api/notifications";
import { updateCurrentUserRedux } from "../../../api/helper";

export default class Notifications extends React.Component {
  state = {
    lastCount: 0,
    notifications: [],
    page: 0,
    pageSize: 10,
    loading: true,
  };
  componentDidMount() {
    this.indexNotifications();
  }
  onScroll = (e) => {
    if (
      !this.state.loading &&
      this.state.lastCount === this.state.pageSize &&
      e.target.scrollHeight - e.target.offsetHeight - e.target.scrollTop <=
        e.target.offsetHeight / 2
    )
      this.setState(
        (prevState) => ({
          page: prevState.page + 1,
        }),
        this.indexNotifications
      );
  };
  indexNotifications = async () => {
    try {
      this.setState({ loading: true });
      let {
        data: { notifications },
      } = await indexNotifications({
        page_size: this.state.pageSize,
        page_number: this.state.page,
      });
      if (this.state.page === 0) updateCurrentUserRedux();
      this.setState((prevState) => ({
        notifications: [...prevState.notifications, ...notifications],
        lastCount: notifications.length,
      }));
    } catch (error) {
      console.log(log_error(error));
    } finally {
      await this.setState({ loading: false });
    }
  };
  render() {
    return (
      <div id="notifications" className="m-4" onScroll={this.onScroll}>
        <h2 className="ml-3">Notifications</h2>
        {this.state.notifications.map((notification) => (
          <Notification key={notification.id} notification={notification} />
        ))}
        {this.state.loading ? <FullPageSpinner className="h-50" /> : null}
      </div>
    );
  }
}
